import Icon from "@/icon";
import { useAppTheme } from "@/theme";
import { Box, Button, Typography } from "@mui/material";
import { t } from "i18next";
import { Link as RSLink } from "react-scroll";

const Footer = () => {
  const theme = useAppTheme();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      textAlign={"center"}
      alignItems={"center"}
      gap={2}
      pt={4}
      borderRadius={theme.shape.borderRadius * 4}
    >
      <Typography variant={"h4"} fontWeight={theme.typography.fontWeightBold}>
        {t("footer.title")}
      </Typography>
      <Typography variant={"subtitle1"}>
        {t("hero.email.text-input.caption")}
      </Typography>
      <Box
        display={"flex"}
        alignItems={"center"}
        flexWrap={"wrap"}
        justifyContent={"center"}
      >
        <RSLink to={"menu"} smooth={true}>
          <Button
            variant={"outlined"}
            sx={{
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
            }}
          >
            {t("hero.email.text-input.button.label")}
          </Button>
        </RSLink>
      </Box>
      <Icon
        icon={"icon"}
        width={32}
        height={32}
        color={theme.palette.primary.main}
      />
      <Typography variant={"caption"} color={"text.secondary"}>
        {t("footer.copyright")}
      </Typography>
    </Box>
  );
};

export default Footer;
